import { init } from '@gympass/i18n';
import { buildCache } from '@gympass/i18n-cache-web';
import { buildFallbackLoader } from '@gympass/i18n-fallback-resource-loader';

import config from 'config';
import { rumService } from 'services/rum';

import localizationNamespaces from '../../../localization-namespaces.json';
import { getLanguage } from './utils';

export function initI18n() {
  init({
    namespaces: localizationNamespaces.namespaces,
    language: getLanguage(),
    cache: buildCache(),
    staging: config.PARTNERS_ENVIRONMENT !== 'production',
    react: {
      transKeepBasicHtmlNodesFor: ['b', 'br', 'i', 'li', 'strong', 'ul'],
    },
    enableOTAUpdate: false,
    fallbackLoader: buildFallbackLoader() as Parameters<
      typeof init
    >[0]['fallbackLoader'],
    defaultNS: localizationNamespaces.namespaces[0],
    missingKeyHandler([language], ns, key) {
      rumService.addError(
        new Error(`Missing translation key: [${language}] ${ns}:${key}`),
      );
    },
  });
}

export type { Country, Currency, Language } from './data';

export {
  defaultLanguage,
  getAvailableCountries,
  LANGUAGES_BY_COUNTRY,
  resolveCountryFromLanguage,
} from './data';

export {
  resolveCurrency,
  resolveCountry,
  cookies,
  getBrowserTimezone,
  getContractLanguageKey,
} from './utils';

export { LOCALE_COOKIE } from './constants';
